import { useQueryParams, useSubmit } from "@certn/api";
import { Text, BasicButton } from "@certn/cascadia";
import {
  BrandAsset,
  Card,
  Layout,
  showToast,
  useColors,
} from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export function CRCVerifCodeRequestPage() {
  const { params } = useQueryParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const colors = useColors();
  const { submit } = useSubmit(
    `/api/internal/applicant/mycrc/create-verification-code/`,
    { throwErrors: true }
  );

  async function handleSubmit() {
    try {
      const data = {
        case_id: params.case_id,
        email_address: Array.isArray(params.email)
          ? params.email[0]
          : params.email,
      };
      await submit(data);
      navigate(
        `/my-crc/certificate/access-code?caseId=${params.case_id}&email=${encodeURIComponent(Array.isArray(params.email) ? params.email[0] : params.email)}`
      );
    } catch (error: any) {
      switch (error.status) {
        case 429:
          showToast(
            t("Too many verification codes requested. Try again later."),
            {
              type: "error",
            }
          );
          break;
        case 404:
          showToast(t("no case with that email for MyCRC exists"), {
            type: "error",
          });
          break;
        case 501:
          showToast(t("Unavailable"), { type: "error" });
          break;
        default:
          console.error(error);
          showToast(t("Something went wrong"), { type: "error" });
      }
    }
  }

  return (
    <Layout backgroundColor="surface-sunken">
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "var(--space-6)",
        }}
      >
        <div style={{ paddingBottom: "var(--space-6)" }}>
          <BrandAsset brand="mycrc" height={32} width={130} />
        </div>
        <Card className={styles.card} border="dropshadow">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "var(--space-6)",
            }}
          >
            <Text style="global/heading-medium">{t("View my results")}</Text>
            <Text>
              {t(
                "To securely access your details, we will send you a 6 character code to your email."
              )}
            </Text>

            <BasicButton fullWidth onPress={handleSubmit}>
              {t("Send access code")}
            </BasicButton>
          </div>
        </Card>
        <div style={{ marginTop: "var(--space-6)" }}>
          <Text color="text-weak" testID="footer-powered-by-link">
            <Trans>
              Powered by{" "}
              <BrandAsset
                height="18"
                width="62"
                type="full"
                brand="certn"
                fill={colors["icon-base"]}
                className={css({ verticalAlign: "middle" })}
              />
            </Trans>
          </Text>
        </div>
      </div>
    </Layout>
  );
}

const styles = {
  card: css({
    width: "100%",
    maxWidth: "277px",
    padding: "var(--space-6)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  }),
};
